"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitorsTableCols = void 0;
const monitors_1 = require("../features/monitors");
/** monitorsTableCols defines the columns the monitors list filter sidebar narrows by. */
exports.monitorsTableCols = [
    {
        name: "Severity",
        id: "severity",
        type: "stringOptions",
        internal: 'm."severity"',
        options: monitors_1.MonitorSeveritySchema.options.map((value) => ({ value })),
    },
    {
        name: "Name",
        id: "name",
        type: "string",
        internal: 'm."name"',
    },
    {
        name: "Status",
        id: "status",
        type: "stringOptions",
        internal: 'm."status"',
        options: monitors_1.MonitorStatusSchema.options.map((value) => ({ value })),
    },
    {
        name: "Tags",
        id: "tags",
        type: "arrayOptions",
        internal: 'm."tags"',
        options: [],
    },
];
